module.exports = __webpack_public_path__ + "img/foto_mediterrane-hoek.88d47cd1.jpg";